export default __webpack_public_path__ + "static/media/user-switch.a89fd2e4.svg";